import utils from "../../../utils/utils";

export default {
    async fetchUserTransactionChartData(context, payload) {
        const queryParameters = utils.utility.checkQueryParams(payload);

        const response = await utils.utility.fetch(`api/dashboard/getuserstransactions?${queryParameters.toString()}`, "GET", null, null);

        context.commit("setUserTransactionChartData", response.data);
    },
    async fetchSentimentAnalysisChartData(context, payload) {
        const queryParameters = utils.utility.checkQueryParams(payload);

        const response = await utils.utility.fetch(`api/dashboard/getsentimentanalysis?${queryParameters.toString()}`, "GET", null, null);

        context.commit("setSentimentAnalysisChartData", response.data);
    },
    async fetchMainCategories(context) {
        const queryObject = {
            categoryType: 1,
            PageSize: 2147000000
        };

        const queryParameters = utils.utility.checkQueryParams(queryObject);

        const response = await utils.utility.fetch(`api/dashboard/getcategories?${queryParameters.toString()}`, "GET", null, null);

        context.commit("setMainCategories", response.data);
    },
    async fetchSubCategories(context) {
        const queryObject = {
            categoryType: 2,
            PageSize: 2147000000
        };

        const queryParameters = utils.utility.checkQueryParams(queryObject);

        const response = await utils.utility.fetch(`api/dashboard/getcategories?${queryParameters.toString()}`, "GET", null, null);

        context.commit("setSubCategories", response.data);
    },
    async fetchDetailCategories(context) {
        const queryObject = {
            categoryType: 3,
            PageSize: 2147000000
        };

        const queryParameters = utils.utility.checkQueryParams(queryObject);

        const response = await utils.utility.fetch(`api/dashboard/getcategories?${queryParameters.toString()}`, "GET", null, null);

        context.commit("setDetailCategories", response.data);
    },
    async fetchOperationTransactionData(context, payload) {
        //const queryParameters = utils.utility.checkQueryParams(payload);

        const response = await utils.utility.fetch("api/dashboard/getoperationtransactions", "POST", null, payload);

        context.commit("setOperationTransactionData", response.data);
    },
    async fetchUserModerationActionsData(context, payload) {
        const queryParameters = utils.utility.checkQueryParams(payload);
        
        const response = await utils.utility.fetch(`api/dashboard/getusermoderationactions?${queryParameters.toString()}`, "GET", null, null);
        
        context.commit("setUserModerationActionsData", response.data);
    },
    selectedServiceLevelTimePeriods(context, payload) {
        context.commit("setSelectedServiceLevelTimePeriods", payload);
    },
    async fetchOperationServiceLevelData(context, payload) {
        //const queryParameters = utils.utility.checkQueryParams(payload);
        
        const response = await utils.utility.fetch("api/dashboard/getoperationservicelevels", "POST", null, payload);

        context.commit("setOperationServiceLevelData", response.data);
    },
    async fetchUserTagData(context, payload) {
        const queryParameters = utils.utility.checkQueryParams(payload);
        
        const response = await utils.utility.fetch(`api/dashboard/getusertaganalysis?${queryParameters.toString()}`, "GET", null, null);

        context.commit("setUserTagData", response.data);
    },
    async fetchMisalignedResponseData(context, payload) {
        const queryParameters = utils.utility.checkQueryParams(payload);
        
        const response = await utils.utility.fetch(`api/dashboard/getoperationresponsecheckers?${queryParameters.toString()}`, "GET", null, null);

        context.commit("setMisalignedResponseData", response.data);
    },
    async postOperationFeedFinalizeData(context, payload) {        
        const response = await utils.utility.fetch(`api/dashboard/postoperationfeedfinalizedata`, "POST", null, payload);
        
        context.commit("setOperationFeedFinalizeData", response.data);
    },
    async fetchTopFeederData(context, payload) {
        const queryParameters = utils.utility.checkQueryParams(payload);        
        const response = await utils.utility.fetch(`api/dashboard/gettopfeeders?${queryParameters.toString()}`, "GET", null, null);  

        context.commit("setTopFeederData", response.data);
    },
    async fetchIdleUserData(context, payload) {
        const response = await utils.utility.fetch("api/dashboard/getidleusers", "POST", null, payload);

        context.commit("setIdleUserData", response.data);
    }
}